<template>
  <div class="Collect">
    <sidebar-nav :routers="routeList" />
  </div>
</template>

<script>
import CollectMixin from '@/mixins/collect/collect.js';
import { getMenuDataById } from '@/utils/route';

export default {
  name: 'Collect',
  mixins: [CollectMixin],
  props: {
    routers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    routeList() {
      if (
        this.collectList &&
        this.collectList.length &&
        this.routers &&
        this.routers.length
      ) {
        let list = this.collectList.map(item => {
          let name = item.menuId.toString();
          return getMenuDataById(this.routers, name);
        });
        list = list.filter(item => !!item);
        return list;
      } else {
        return [];
      }
    },
  },
};
</script>
